import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";

import "./css/common.css";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <HashRouter>
        <App />
    </HashRouter>
);
